'use client'
import React from 'react'
import Link from 'next/link'
import { usePathname } from 'next/navigation'

const LinkComponent = ({ href, newTab = false, className, children }) => {
    // const segments = useSelectedLayoutSegments()
    const pathname = usePathname()
    const segments = pathname.split('/')

    let link = href
    const languages = ['en', 'cn', 'th']
    if (segments.length > 1 && languages.includes(segments[1])) {
        link = `/${segments[1]}${href}`
    }

    return (
        <Link
            href={link}
            target={newTab ? '_blank' : undefined}
            rel={newTab ? 'noopener noreferrer' : undefined}
            className={className} 
         >
            {children}
        </Link>
    )
}

export default LinkComponent